import { render, staticRenderFns } from "./TheFooterMaster.vue?vue&type=template&id=609154c8&scoped=true"
import script from "./TheFooterMaster.vue?vue&type=script&lang=ts"
export * from "./TheFooterMaster.vue?vue&type=script&lang=ts"
import style0 from "./TheFooterMaster.vue?vue&type=style&index=0&id=609154c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609154c8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsBookingSpecial: require('/usr/src/nuxt-app/components/elements/BookingSpecial.vue').default})
